export let tuesdayUppercase = "F5mJub";
export default {tuesdayUppercase};